import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';

import TransporteurSelect from 'components/Shared/TransporteurSelect';
import DropZone from 'components/Shared/DropZone';
import ArticleGestionSearch from 'components/Shared/ArticleGestionSearch';
import MyDatePicker from 'components/Shared/MyDatePicker';

import { ReclamationActionDetailCodes } from 'constants.js';
import { ReclamationActionDetailType } from 'constants.js';
import { AdresseDestinations } from 'constants.js';

import { getTransporteurEmail } from 'utils/transporteursHelper';

const styles = theme => ({
    detailValue: {
        paddingLeft: theme.spacing(4)
    },

    marginTop: {
        marginTop: 10
    },
    
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
    },


    codePostal: {
        flexBasis: '25%'
    },

    ville: {
        flexBasis: '75%',
        flexGrow: 1
    },

    column: {
        width: '45%'
    },

    cell: {
        padding: '4px 8px 4px 8px'
    }
});

class DemandeEnlevementContent extends React.Component {

    constructor(props) {
        super(props);
        
        let articles = JSON.parse(JSON.stringify(props.articles));
        articles = articles.map((x) => {
            return { ...x, quantiteAEnlever: 0 };
        });

        this.state = {

            transporteurId: props.transporteurId,
            destinataires: getTransporteurEmail(props.transporteurId, props.transporteurs, props.depotDepart),
            memo: '',
            fichiersIds: [],
            notifierTransporteur: true,

            adresseEnlevementNomLivraison: this.props.adresse && this.props.adresse.nomLivraison ? this.props.adresse.nomLivraison : '',
            adresseEnlevementAdresse1: this.props.adresse && this.props.adresse.adresse1 ? this.props.adresse.adresse1 : '',
            adresseEnlevementAdresse2: this.props.adresse && this.props.adresse.adresse2 ? this.props.adresse.adresse2 : '',
            adresseEnlevementCodePostal: this.props.adresse && this.props.adresse.codePostal ? this.props.adresse.codePostal : '',
            adresseEnlevementVille: this.props.adresse && this.props.adresse.ville ? this.props.adresse.ville : '',

            contactClientNom: this.props.contact && this.props.contact.nom ? this.props.contact.nom : '',
            contactClientEmail: this.props.contact && this.props.contact.email ? this.props.contact.email : '',
            contactClientTelephone: this.props.contact && this.props.contact.telephone ? this.props.contact.telephone : '',

            dateSouhaitee: null,

            adresseDestinationCode: '',
            adresseDestinationNom: '',
            adresseDestinationAdresse1: '',
            adresseDestinationAdresse2: '',
            adresseDestinationCodePostal: '',
            adresseDestinationVille: '',


            articles: articles,
            poidsTheorique: 0,
            nbPalettes: 0,
            nbColis: 0,
            nbLongueurs: 0,

            articleHorsPiece: null,
            codeTR : ''
        };
    }

    componentDidMount() {
        let actionData = this.getActionData(this.state);

        this.props.onChange(actionData);
    }

    getActionData(newState) {
        const { action } = this.props;

        if (!newState.transporteurId) {
            return null;
        }

        if (newState.notifierTransporteur && !newState.destinataires) {
            return null;
        }

        if (!newState.adresseEnlevementNomLivraison
            || !newState.adresseEnlevementAdresse1
            || !newState.adresseEnlevementCodePostal
            || !newState.adresseEnlevementVille
           ) {
            return null;
        }

        if (!newState.contactClientNom
            || !newState.contactClientEmail
            || !newState.contactClientTelephone
           ) {
            return null;
        }

        if (!newState.poidsTheorique) {
            return null;
        }

        if (!newState.nbColis && !newState.nbPalettes && !newState.nbLongueurs) {
            return null;
        }

        if (newState.adresseDestinationCode === '') {
            return null;
        }

        if (newState.adresseDestinationCode === 3
            && (!newState.adresseDestinationNom
                || !newState.adresseDestinationAdresse1
                || !newState.adresseDestinationCodePostal
                || !newState.adresseDestinationVille)
        ) {
            return null;
        }


        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Transporteur,
                type: ReclamationActionDetailType.TransporteurId,
                libelle: 'Transporteur',
                position: 0,
                valeurInteger: newState.transporteurId
            }, {
                code: ReclamationActionDetailCodes.Adresse,
                type: ReclamationActionDetailType.Texte,
                libelle: `Adresse d'enlèvement`,
                position: 1,
                valeurString: `${newState.adresseEnlevementNomLivraison}\n${newState.adresseEnlevementAdresse1}\n${newState.adresseEnlevementAdresse2}\n${newState.adresseEnlevementCodePostal} ${newState.adresseEnlevementVille}`
            }, {
                code: ReclamationActionDetailCodes.ContactClient,
                type: ReclamationActionDetailType.Texte,
                libelle: `Contact client nécessaire à l'enlèvement`,
                position: 2,
                valeurString: `${newState.contactClientNom} (${newState.contactClientEmail} / ${newState.contactClientTelephone})`
            }]
        };

        if (newState.dateSouhaitee !== null) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.DateEnlevement,
                type: ReclamationActionDetailType.Date,
                libelle: `Date d'enlèvement`,
                position: actionData.details.length,
                valeurDate: newState.dateSouhaitee.toDateString()
            });
        }


        let adresseString = `${newState.adresseDestinationNom}\n${newState.adresseDestinationAdresse1}\n${newState.adresseDestinationAdresse2 ? newState.adresseDestinationAdresse2 + "\n" : ""}${newState.adresseDestinationCodePostal} ${newState.adresseDestinationVille}`;
        if (newState.adresseDestinationCode !== 3) {
            if (AdresseDestinations.find(x => x.id === newState.adresseDestinationCode) !== undefined) {
                adresseString = AdresseDestinations.find(x => x.id === newState.adresseDestinationCode).nom;
            }
        }

        actionData.details.push({
            code: ReclamationActionDetailCodes.AdresseDestination,
            type: ReclamationActionDetailType.Texte,
            libelle: `Adresse de destination`,
            position: actionData.details.length,
            valeurString: adresseString,
            valeurInteger: newState.adresseDestinationCode
        });

        // Articles à enlever
        let articles = newState.articles.filter(x => x.quantiteAEnlever !== 0);
        if (articles.length === 0) {
            return null;
        }
        for (let i = 0; i < articles.length; i++) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.CodeArticleQuantite,
                type: ReclamationActionDetailType.CodeArticleQuantite,
                libelle: 'Code article à enlever avec quantité',
                position: actionData.details.length,
                valeurInteger: articles[i].quantiteAEnlever,
                valeurString: articles[i].codeArticle
            });
        }

        // Poids théorique
        actionData.details.push({
            code: ReclamationActionDetailCodes.Poids,
            type: ReclamationActionDetailType.Entier,
            libelle: 'Poids théorique',
            position: actionData.details.length,
            valeurInteger: newState.poidsTheorique
        });

        // Nombre de colis
        actionData.details.push({
            code: ReclamationActionDetailCodes.NombreColis,
            type: ReclamationActionDetailType.Entier,
            libelle: 'Nombre de colis',
            position: actionData.details.length,
            valeurInteger: newState.nbColis
        });
        
        // Nombre de palettes
        actionData.details.push({
            code: ReclamationActionDetailCodes.NombrePalettes,
            type: ReclamationActionDetailType.Entier,
            libelle: 'Nombre de palettes',
            position: actionData.details.length,
            valeurInteger: newState.nbPalettes
        });

        // Nombre de longueurs
        actionData.details.push({
            code: ReclamationActionDetailCodes.NombreLongueurs,
            type: ReclamationActionDetailType.Entier,
            libelle: 'Nombre de longueurs',
            position: actionData.details.length,
            valeurInteger: newState.nbLongueurs
        });


        if (newState.notifierTransporteur) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Email,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Email(s) destinataire(s)',
                position: actionData.details.length,
                valeurString: newState.destinataires
            });
        }
        else {
            // On n'ajoute pas le mail dans les détails, ce qui suffit à empêcher l'envoi :)
        }

        actionData.details.push({
            code: ReclamationActionDetailCodes.Notifier,
            type: ReclamationActionDetailType.Booleen,
            libelle: 'Envoyer un mail au transporteur',
            position: actionData.details.length,
            valeurBool: newState.notifierTransporteur
        });

        // Mémo
        actionData.details.push({
            code: ReclamationActionDetailCodes.Memo,
            type: ReclamationActionDetailType.Texte,
            libelle: 'Mémo',
            position: actionData.details.length,
            valeurString: newState.memo
        });

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }


        // TranporteurInitial
        actionData.details.push({
            code: ReclamationActionDetailCodes.TransporteurInitial,
            type: ReclamationActionDetailType.Texte,
            libelle: 'Transporteur initial',
            position: actionData.details.length,
            valeurString: this.props.transporteurInitial ? this.props.transporteurInitial.nom + ' / ' + this.props.transporteurInitial.contrat : ''
        });

        return actionData;
    }

    handleChange = (event, codeArticle) => {
        const { transporteurs, depotDepart } = this.props;

        let newState;
        if (codeArticle) {
            
            newState = {
                ...this.state,
                articles: this.state.articles.map(article => { let a = article.codeArticle !== codeArticle ? article : { ...article, quantiteAEnlever: Math.max(Number(event.target.value), 0) }; return a; })
            };

            newState.poidsTheorique = newState.articles.reduce((currentValue, nextValue) => currentValue + Number(nextValue.quantiteAEnlever) * nextValue.poids, 0);
        } else {
            newState = {
                ...this.state,
                [event.target.name]: event.target.value
            };
        }

        if (event.target.name === 'transporteurId') {
            newState.destinataires = getTransporteurEmail(newState.transporteurId, transporteurs, depotDepart);
        }

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }



    handleChangeInteger = (event) => {

        let newState;

        newState = {
            ...this.state,
            [event.target.name]: Math.max(event.target.value,0)
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    handleChangeArticleGestion = (suggestion) => {
        
        if (!suggestion) {
            return;
        }

        let newState;

        newState = {
            ...this.state,
            articleHorsPiece: { codeArticle: suggestion.reference, designationArticle: suggestion.designation, quantite: 0, poids: suggestion.poids, positionnement: suggestion.positionnement}
        };

        this.setState(newState);
    }

    handleAddArticle = () => {
        let newState;
        let newArticle = JSON.parse(JSON.stringify(this.state.articleHorsPiece));
        newArticle.quantiteAEnlever = 0;

        newState = {
            ...this.state,
            articles: [...this.state.articles, newArticle],
            articleHorsPiece: null
        };

        this.props.clearArticleGestionValue();

        this.setState(newState);
        let actionData = this.getActionData(newState);
        this.props.onChange(actionData);
    }

    handleAddTR = () => {
        let newState;
        let newArticle = {
            codeArticle: this.state.codeTR,
            designationArticle: "N/A",
            poids: 0,
            positionnement: "N/A",
            quantite: 0,
            quantiteAEnlever: 0

        };

        newState = {
            ...this.state,
            articles: [...this.state.articles, newArticle],
            codeTR: ''
        };

        this.setState(newState);
        let actionData = this.getActionData(newState);
        this.props.onChange(actionData);
    }


    render() {
        const { classes, transporteurInitial } = this.props;
        const { transporteurId, notifierTransporteur } = this.state;

        let addArticleDisabled = !this.state.articleHorsPiece || !this.state.articleHorsPiece.codeArticle || this.state.articleHorsPiece.codeArticle.length === 0;

        if (!addArticleDisabled) {
            addArticleDisabled = this.state.articles.find(x => x.codeArticle === this.state.articleHorsPiece.codeArticle) !== undefined;
        }

        return (
            <React.Fragment>


                <FormControlLabel
                    control={
                        <Switch
                            checked={notifierTransporteur}
                            onChange={e => this.handleChange({ target: { name: "notifierTransporteur", value: !notifierTransporteur } })}
                            value="notifierTransporteur"
                            color="secondary"
                        />
                    }
                    label="Envoyer un mail au transporteur&nbsp;:&nbsp;"
                    labelPlacement="start"
                />

                <TransporteurSelect value={transporteurId} onChange={e => this.handleChange(e)} all={false} isRequired />

                {notifierTransporteur && <TextField className={classes.input} id="destinataires" name="destinataires" label='Destinataires du mail (séparé par un ";")' type="text" value={this.state.destinataires} onChange={e => this.handleChange(e)} fullWidth required />}


                <div className={classes.container}>
                    <div className={classes.column}>

                        <div>
                            <Typography variant="h6" gutterBottom>{`Adresse d'enlèvement :`}</Typography>
                            <Stack spacing={1}>
                                <TextField required name="adresseEnlevementNomLivraison" label="Nom" value={this.state.adresseEnlevementNomLivraison} onChange={e => this.handleChange(e)} fullWidth />
                                <TextField required name="adresseEnlevementAdresse1" label="Adresse" value={this.state.adresseEnlevementAdresse1} onChange={e => this.handleChange(e)} fullWidth />
                                <TextField name="adresseEnlevementAdresse2" label="Complément" value={!this.state.adresseEnlevementAdresse2 ? '' : this.state.adresseEnlevementAdresse2} onChange={e => this.handleChange(e)} fullWidth />
                                <TextField required name="adresseEnlevementCodePostal" label="Code Postal" value={this.state.adresseEnlevementCodePostal} onChange={e => this.handleChange(e)} />
                                <TextField required name="adresseEnlevementVille" label="Ville" value={this.state.adresseEnlevementVille} onChange={e => this.handleChange(e)} />
                            </Stack>
                        </div>

                        <div>
                            <Typography variant="h6" gutterBottom className={classes.marginTop}>Contact client nécessaire à l'enlèvement :</Typography>
                            <Stack spacing={1}>
                                <TextField required name="contactClientNom" label="Nom" value={this.state.contactClientNom} onChange={e => this.handleChange(e)} fullWidth />
                                <TextField required name="contactClientEmail" label="Email" value={this.state.contactClientEmail} onChange={e => this.handleChange(e)} fullWidth />
                                <TextField required name="contactClientTelephone" label="Téléphone" value={this.state.contactClientTelephone} onChange={e => this.handleChange(e)} fullWidth />
                            </Stack>

                        </div>
                    </div>

                    <div className={classes.column}>


                        <div>
                            <Typography variant="h6" gutterBottom>Adresse de destination :</Typography>

                            <TextField
                                id="adresseDestinationCode"
                                name="adresseDestinationCode"
                                label={"Destination"}
                                fullWidth
                                required
                                select

                                SelectProps={{
                                    value: this.state.adresseDestinationCode,
                                    onChange: (e) => this.handleChange(e),
                                    autoFocus: true
                                }}
                            >

                                {AdresseDestinations.map(adresse => (

                                    <MenuItem key={adresse.id} value={adresse.id}>{adresse.nom}</MenuItem>

                                ))}
                            </TextField>

                            {this.state.adresseDestinationCode === 3 && (
                                <Stack spacing={1} mt={1}>
                                    <TextField required name="adresseDestinationNom" label="Nom" value={this.state.adresseDestinationNom} onChange={e => this.handleChange(e)} fullWidth autoFocus />
                                    <TextField required name="adresseDestinationAdresse1" label="Adresse" value={this.state.adresseDestinationAdresse1} onChange={e => this.handleChange(e)} fullWidth />
                                    <TextField          name="adresseDestinationAdresse2" label="Complément" value={this.state.adresseDestinationAdresse2} onChange={e => this.handleChange(e)} fullWidth />
                                    <TextField required name="adresseDestinationCodePostal" label="Code Postal" value={this.state.adresseDestinationCodePostal} onChange={e => this.handleChange(e)} />
                                    <TextField required name="adresseDestinationVille" label="Ville" value={this.state.adresseDestinationVille} onChange={e => this.handleChange(e)} />
                                </Stack>
                            )}
                        </div>



                        {transporteurInitial && (
                            <div>

                                <Typography variant="h6" gutterBottom className={classes.marginTop}>Transporteur initial :</Typography>

                                <Typography gutterBottom>{transporteurInitial.nom} / {transporteurInitial.contrat}</Typography>

                            </div>
                        )}

                    </div>
                </div>

                <div>
                    <Typography variant="h6" className={classes.marginTop} gutterBottom>Article(s) à enlever :</Typography>

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.cell}>Code article</TableCell>
                                <TableCell className={classes.cell}>Désignation</TableCell>
                                <TableCell className={classes.cell}>Quantité<br/>commandé</TableCell>
                                <TableCell className={classes.cell}>Quantité à enlever</TableCell>
                                <TableCell className={classes.cell}>Poids unitaire</TableCell>
                                <TableCell className={classes.cell}>Positionnement</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.articles.map(x => (
                                <TableRow key={x.codeArticle}>
                                    <TableCell className={classes.cell}>{x.codeArticle}</TableCell>
                                    <TableCell className={classes.cell}>{x.designationArticle}</TableCell>
                                    <TableCell className={classes.cell}>{x.quantite}</TableCell>
                                    <TableCell className={classes.cell}><TextField size="small" type="number" value={x.quantiteAEnlever} onChange={e => this.handleChange(e, x.codeArticle)} /></TableCell>
                                    <TableCell className={classes.cell}>{x.poids} g</TableCell>
                                    <TableCell className={classes.cell}>{x.positionnement}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>


                    <Stack direction="row" mt={1} spacing={1} justifyContent="space-between">
                        <Stack spacing={1} sx={{ flexGrow: 1 }} alignItems="flex-start">
                            <ArticleGestionSearch namespace="addAction" onChange={this.handleChangeArticleGestion} isRequired={false} label="Article hors pièce" infosLogistique />

                            <Button onClick={this.handleAddArticle} disabled={addArticleDisabled}>Ajouter</Button>

                        </Stack>
                        <Stack spacing={1} sx={{ flexGrow: 1 }} alignItems="flex-start">
                            <TextField name="codeTR" label="Code TR" value={this.state.codeTR} onChange={e => this.handleChange(e)} fullWidth />

                            <Button onClick={this.handleAddTR} disabled={this.state.codeTR === ''}>Ajouter TR</Button>

                        </Stack>

                    </Stack>

                    <div>
                        <Typography variant="h6" gutterBottom>Expédition :</Typography>

                        <MyDatePicker
                            label="Date d'enlèvement souhaitée"
                            value={this.state.dateSouhaitee}
                            onChange={value => this.handleChange({ target: { name: 'dateSouhaitee', value: value } })}
                            disableFuture={false}
                            disablePast={true}
                            disableSunday={true}
                            fullWidth
                        />


                        <TextField required name="poidsTheorique" label="Poids théorique (en g)" value={this.state.poidsTheorique} onChange={this.handleChangeInteger} className={classes.marginTop} fullWidth />
                        <div className={classes.container}>
                            <TextField className={classes.marginTop} name="nbPalettes" label="Nombre de palettes" type="number" value={this.state.nbPalettes} onChange={this.handleChangeInteger} />
                            <TextField className={classes.marginTop} name="nbColis" label="Nombre de colis" type="number" value={this.state.nbColis} onChange={this.handleChangeInteger} />
                            <TextField className={classes.marginTop} name="nbLongueurs" label="Nombre de longueurs" type="number" value={this.state.nbLongueurs} onChange={this.handleChangeInteger} />
                        </div>
                    </div>
                </div>

                <TextField className={classes.input} id="memo" name="memo" label="Mémo" type="text" value={this.state.memo} onChange={e => this.handleChange(e)} fullWidth multiline />

                <DropZone id="fichiersIds" name="fichiersIds" onChange={e => this.handleChange(e)} />

            </React.Fragment>
        );
    }
}

DemandeEnlevementContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    articles: PropTypes.array.isRequired,
    adresse: PropTypes.object
};

export default withStyles(styles)(DemandeEnlevementContent);